import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../../application/config/config';
import Fetch from "../../../../../core/util/core/Fetch";

function Form(props) {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/bimanagers/';
    const paths = {
        endpointSave: config.endpoints.backend + 'bimanagers/save',
        endpointGetById: config.endpoints.backend + 'bimanagers/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Gestor de BI",
        labelTitleEdit: "Editar Gestor de BI",
        labelTitleView: 'Visualizar Gestor de BI'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            handleSubmit: props.handleSubmit(),
            fields: [
                {
                    name: 'pdc_company_id',
                    type: 'select',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'corporate_name',
                        value: 'id'
                    },
                    label: 'Empresa',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'cpf',
                    type: 'CPF',
                    label: 'CPF',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto',
                    uploadPath: '/bimanagers/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'login',
                    type: 'text',
                    label: 'Login',
                    validations: {
                        required: true,
                        login: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password',
                    type: 'password',
                    label: 'Senha',
                    validations: {
                        password: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password_confirm',
                    type: 'password',
                    label: 'Repetir senha',
                    validations: {
                        password_confirm: true
                    },
                    columnSize: 12
                },
                {
                    name: 'birth_date',
                    type: 'date',
                    label: 'Data de Nascimento',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'rg',
                    type: 'RG',
                    label: 'RG',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'social_name',
                    type: 'text',
                    label: 'Nome Social',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'gender',
                    type: 'select',
                    label: 'Gênero',
                    options: [
                        { label: 'Masculino', value: 'M' },
                        { label: 'Feminino', value: 'F' },
                        { label: 'Não Identificar', value: 'NI' },
                        { label: 'Ignorado', value: 'I' },
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                password: (value, options, key, attributes) => {
                    if (value.length < 8 && value.length > 0) {
                        return '^A senha deve ter no minímo 8 caracteres';
                    } else {
                        return '';
                    }
                },
                password_confirm: (value, options, key, attributes) => {
                    if (value !== attributes.password_confirm) {
                        return '^O campo repetir senha deve ter igual ao campo senha';
                    } else {
                        return '';
                    }
                },
                login: async (value, options, key, attributes) => {
                    const checkLogin = async (value) => {
                        const post = {
                            login: value
                        };

                        if (id) {
                            const post_manager = {
                                id
                            };

                            const manager = await Fetch.post(config.endpoints.backend + 'bimanagers/getById', post_manager);
                            post.user_id = manager.core_user_id;
                        }

                        if (value.trim().length > 2) {
                            let response = await Fetch.post(config.endpoints.backend + 'core/users/getbylogin', post);
                            if (response.id) {
                                return '^O login já está sendo utilizado por outro usuário';
                            }
                        }

                        return "";
                    }
                    return checkLogin(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
